export default {"src":"__ASTRO_ASSET_IMAGE__C0Luf6ra__","width":25,"height":24,"format":"svg"}